const getCartPrices = (prices, shippingMethod) => ({
  discountPrice: prices.discount.amount,
  paymentMethodPrice: prices.paymentMethodPrice ?? void 0,
  // PreDiscountPrice is the price before any discounts are subtracted (this was subtotal before)
  preDiscountPrice: prices.subtotal,
  // Subtotal currently shows the final price without any shipping costs or total cart discounts (which are currently not implemented)
  subTotalPrice: prices.gross - prices.shippingPrice,
  shippingPrice: prices.shippingPrice,
  totalPrice: prices.gross,
  taxPrice: prices.tax.amount,
  taxRate: prices.tax.portions[0]?.rate ?? 0,
  shippingTaxRate: shippingMethod?.pricing?.taxRate || 0,
  shippingDiscount: prices.shippingPrice ? shippingMethod?.pricing.priceWithoutDiscounts - prices.shippingPrice : 0,
  appliedDiscounts: prices.discount.appliedDiscounts.map((discountItem) => ({
    type: discountItem.type,
    value: discountItem.amount
  }))
});
export {
  getCartPrices
};
//# sourceMappingURL=get-cart-prices.js.map
